<template>
    <section>
        <h1>Radicacion</h1>
    </section>
</template>
<script>
    export default {
        setup () {
            return {}
            }

        }
</script>
<style scoped>
</style>
